import { observer } from "mobx-react-lite";

import { useNodeThemeColors } from "@/components/expression/theme/useNodeTheme";
import * as Decorator from "@/components/expression/utils/decorators/Layout";
import { useIsSelected } from "@/components/expression/utils/layout";
import { useNodeStyle } from "@/components/expression/utils/NodeStyleProvider";
import { twMerge } from "@/utils/twMerge";

import HatIcon from "./icons/HatIcon.svg";

import type { DecoratorNodeModel } from "@/models/nodes/DecoratorNodeModel";

type Props = {
  node: DecoratorNodeModel;
};

export const Hat = observer(function Hat({ node }: Props) {
  const { parent: symbolNode } = node;

  const isSelected = useIsSelected(symbolNode?.parent);
  const { view } = useNodeStyle();
  const theme = useNodeThemeColors(symbolNode?.parent);

  const isTextView = view === "text";

  return (
    <Decorator.HatBackground
      hatClassName={twMerge(
        !isTextView &&
          theme?.background &&
          `bg-${theme.background.light} dark:bg-${theme.background.dark}`,
        !isTextView && isSelected && `fromSm:bg-selected-bg`,
      )}
    >
      <HatIcon
        className={twMerge(
          theme?.symbol && `stroke-${theme.symbol.light} dark:stroke-${theme.symbol.dark}`,
        )}
      />
    </Decorator.HatBackground>
  );
});
